/* @generated */

// src/assets/ui-icon/line/rocket.tsx
import * as React from "react";
var RocketLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.339 7.226c.476-.476.938-.476 1.414 0 .476.475.476.938 0 1.414s-.938.476-1.414 0-.476-.939 0-1.414Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.321 4.274-.088-.528-.528-.088c-1.826-.304-4.068-.01-5.975 1.106a7.95 7.95 0 0 0-1.712 1.343l-1.387.04a1.5 1.5 0 0 0-1.017.44L6.5 9.7l1.06 1.06 2.404-.77a10.25 10.25 0 0 0-.153.829l-.053.37.985.986-1.591 1.59 1.06 1.061 1.591-1.59.985.984.371-.053c.286-.04.562-.092.83-.153l-.772 2.403 1.061 1.061 3.114-3.114a1.5 1.5 0 0 0 .44-1.017l.04-1.387a7.952 7.952 0 0 0 1.343-1.712c1.116-1.907 1.41-4.15 1.106-5.975Zm-5.866 6.31-1.591 1.592.448.447c2.278-.423 3.744-1.656 4.608-3.132.816-1.393 1.105-3.022.99-4.422-1.4-.115-3.029.174-4.422.99-1.476.864-2.709 2.33-3.132 4.608l.447.448 1.591-1.591 1.06 1.06Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M7.09 13.455 3.5 17.008l1.055 1.065 3.59-3.552-1.056-1.066Zm2.6 2.37L7.083 18.4l1.054 1.068 2.609-2.574-1.054-1.068Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  RocketLine
};
